
import { defineComponent } from "vue";
import { usePlugin } from "@/plugins";

export default defineComponent({
  name: "BackButton",
  setup() {
    const { onBack } = usePlugin();
    return {
      onBack,
    };
  },
});
